import { useMemo } from 'react';

import { useSiteManagementLocationsQuery } from '@occc/graphql';
import { transformDataToSiteManagementLocationsArray } from '@occc-app/dataAccessLayer/location/utils';
import { ChipList } from '@occc-app/routes/CampaignComponents/component-details/components';
import { routeCreator as locationRouteCreator } from '@occc-app/routes/Location/utils';

type StoreChipsProps = {
  storeIds: string[];
  label: string;
  emptyPlaceholder?: string;
};

export const StoreChips = ({ storeIds, label, emptyPlaceholder }: StoreChipsProps) => {
  const { data, loading } = useSiteManagementLocationsQuery({
    fetchPolicy: 'cache-and-network',
    skip: storeIds.length === 0,
    variables: {
      filter: { uuidContains: storeIds },
      first: storeIds.length || 1,
    },
  });

  const chips = useMemo(() => {
    const locations = data ? transformDataToSiteManagementLocationsArray(data) : [];
    return locations.map((location) => ({
      label: location?.siteSystemConfiguration[0]?.identifier ?? location.uuid,
      href: locationRouteCreator.generalDetails(location.uuid),
    }));
  }, [data]);

  return (
    <ChipList isLoading={loading} label={label} items={chips} emptyPlaceholder={emptyPlaceholder} />
  );
};
